import React from "react";
import "./allProducts.css";
import { Link, useParams } from "react-router-dom";
import { productData } from "../../productData";
import ProductCard from "./productCard";

const AllProducts = () => {
    const { category } = useParams();


    const filteredProducts = productData.filter(
        (p) => p.category === category
    );


    const pageTitle =
        category.charAt(0).toUpperCase() + category.slice(1).replace("-", " ");

    return (
        <>
            <div className="top-img bg">

                <div className="top-content">
                    <h1>{pageTitle}</h1>
                    <div className="top-link">
                        <div className="home-link">
                            <Link to="/">Home</Link>
                        </div>
                        <div className="currentpage">{pageTitle}</div>
                    </div>
                </div>
            </div>

            <div className="products-container">
                <div className="product-content"  data-aos="fade-up">
                    <h2 className="content-title" style={{ color: "black" }}>{pageTitle}</h2>

                    <div className="allproduct-container">
                        <div className="product-list">
                            {filteredProducts.length > 0 ? (
                                filteredProducts.map((item) => (
                                    <ProductCard key={item.id} item={item} />
                                ))
                            ) : (
                                <p>No products found </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AllProducts;
